import React from 'react'
import { Container, Typography } from '@mui/material'
import ContactCard from './ContactCard'
import lightTheme from '../theme'

export default function ContactCardView() {
  return (
    <Container id='contact' maxWidth={false} sx={{backgroundColor: lightTheme.palette.complementary.main}}>
      <Container>
        <Typography variant='h2' sx={{padding:'20px 0px'}}>Contact Us</Typography>
        <ContactCard/>
      </Container>
    </Container>
  )
}
